// material-ui
import { Box, Button, Grid, Stack, Typography } from '@mui/material';

// assets
import Error403 from 'assets/images/maintenance/Error403.png';
import { APP_DEFAULT_PATH } from 'config';
import { Link } from 'react-router-dom';

// ==============================|| UNDER CONSTRUCTION - MAIN ||============================== //

function AccessDenied({ sx }) {
  return (
    <Grid container spacing={4} direction="column" alignItems="center" justifyContent="center" sx={{ minHeight: '100vh', py: 2, ...sx }}>
      <Grid item xs={12}>
        <Box sx={{ width: { xs: 270, sm: 400 } }}>
          <img src={Error403} alt="cs-ats" style={{ width: '100%', height: 'auto' }} />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Stack spacing={2} justifyContent="center" alignItems="center">
          <Typography align="center" variant="h1">
            Access Denied
          </Typography>
          <Typography color="textSecondary" align="center">
            You are not authorized to access this page.
          </Typography>
          <Button component={Link} to={APP_DEFAULT_PATH} variant="contained">
            Back To Home
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default AccessDenied;
